import { postRaw } from 'services/api';

/**
 * uploadEventURL
 * Posts Body and apiKey to Endpoint
 * @param { String } apiKey: The apiKey to request with
 * @param { Object } body: The event json to post
 * @param { String } endpoint: The api endpoint to post request to
 * @returns { Promise } Status from Request
 */
export function uploadEventURL(apiKey, body, endpoint) {
  return postRaw(`/api/${endpoint}?api_key=${apiKey}`, body);
}
